module.exports = __webpack_public_path__ + "img/Autocolant TCLH_55mm x 60mm-01.c3bb2101.jpg";